import { Controller } from '@hotwired/stimulus'

// Connects to data-controller="wizard-v2--client-type"
export default class extends Controller {
  static values = { companyType: String }
  static targets = [
    'template',
    'templateName',
    'accountMappingSelect',
    'accountMappingSelectContainer',
    'accountMappingStaticWrapper',
    'accountMappingStaticMappingName',
    'displayedLocales',
    'pickLocales',
    'locales',
    'workflow',
    'templateSettingsLink',
  ]

  private templateTarget!: HTMLSelectElement
  private templateNameTarget!: HTMLDivElement
  private accountMappingSelectTarget!: HTMLSelectElement
  private accountMappingSelectContainerTarget!: HTMLElement
  private accountMappingStaticWrapperTarget!: HTMLElement
  private accountMappingStaticMappingNameTarget!: HTMLElement
  private displayedLocalesTarget!: HTMLDivElement
  private pickLocalesTarget!: HTMLDivElement
  private localesTarget!: HTMLElement
  private workflowTargets!: HTMLElement[]
  private templateSettingsLinkTarget!: HTMLAnchorElement
  private hasTemplateSettingsLinkTarget!: boolean
  private companyTypeValue!: string

  connect(): void {
    this.handleTemplateChange()
  }

  handleTemplateChange(): void {
    const selectedTemplate =
      this.templateTarget.options[this.templateTarget.selectedIndex]
    const templateName = selectedTemplate.text || ''

    this.templateNameTarget.textContent = templateName

    if (this.hasTemplateSettingsLinkTarget && this.templateTarget.value) {
      const firmId = window.location.pathname.split('/')[2]
      const templateId = this.templateTarget.value
      this.templateSettingsLinkTarget.href =
        window.Silverfin.Routes.edit_company_template_path(firmId, templateId)
    }

    if (this.companyTypeValue !== 'personal') {
      this.updateAccountMapping(selectedTemplate)
    }
    this.updateLocales(selectedTemplate)
    this.updateWorkflows()
  }

  private updateAccountMapping(selectedTemplate: HTMLOptionElement): void {
    const accountMappingListId =
      selectedTemplate.dataset.accountMappingListId || ''
    const shouldShowAccountMappingSelect = accountMappingListId === ''

    if (shouldShowAccountMappingSelect) {
      this.accountMappingSelectContainerTarget.classList.remove('tw-hidden')
      this.accountMappingStaticWrapperTarget.classList.add('tw-hidden')
    } else {
      this.accountMappingStaticMappingNameTarget.textContent =
        selectedTemplate.dataset.accountMappingName || 'Silverfin LTD'
      this.accountMappingSelectContainerTarget.classList.add('tw-hidden')
      this.accountMappingStaticWrapperTarget.classList.remove('tw-hidden')
    }
  }

  private updateLocales(selectedTemplate: HTMLOptionElement): void {
    const localesData = selectedTemplate.dataset.locales || ''
    const hasLocales = this.templateTarget.value !== '' && localesData !== ''

    this.displayedLocalesTarget.classList.toggle('tw-hidden', !hasLocales)
    this.pickLocalesTarget.classList.toggle('tw-hidden', hasLocales)

    if (hasLocales) {
      this.localesTarget.textContent = localesData
    }
  }

  private updateWorkflows(): void {
    this.workflowTargets.forEach((workflow) => {
      const partOfCurrentTemplate =
        workflow.dataset.companyTemplateId === this.templateTarget.value
      workflow.classList.toggle('tw-hidden', !partOfCurrentTemplate)
    })
  }
}
